// source: stailer/externaladminrpc/delivery_area_group.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var type_ec_site_pb = require('../../type/ec_site_pb.js');
goog.object.extend(proto, type_ec_site_pb);
goog.exportSymbol('proto.stailer_external_admin.DeliveryAreaGroup', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stailer_external_admin.DeliveryAreaGroup = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.stailer_external_admin.DeliveryAreaGroup, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stailer_external_admin.DeliveryAreaGroup.displayName = 'proto.stailer_external_admin.DeliveryAreaGroup';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stailer_external_admin.DeliveryAreaGroup.prototype.toObject = function(opt_includeInstance) {
  return proto.stailer_external_admin.DeliveryAreaGroup.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stailer_external_admin.DeliveryAreaGroup} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.DeliveryAreaGroup.toObject = function(includeInstance, msg) {
  var f, obj = {
    groupId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    groupName: jspb.Message.getFieldWithDefault(msg, 3, ""),
    shopId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    siteType: jspb.Message.getFieldWithDefault(msg, 5, 0),
    id: jspb.Message.getFieldWithDefault(msg, 6, ""),
    createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of DeliveryAreaGroup as accepted by the `fromObject` method.
 * @record
 */
proto.stailer_external_admin.DeliveryAreaGroup.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.groupId;

  /** @type {?|undefined} */
  this.groupName;

  /** @type {?|undefined} */
  this.shopId;

  /** @type {?|undefined} */
  this.siteType;

  /** @type {?|undefined} */
  this.id;

  /** @type {?|undefined} */
  this.createdAt;

  /** @type {?|undefined} */
  this.updatedAt;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.stailer_external_admin.DeliveryAreaGroup.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.stailer_external_admin.DeliveryAreaGroup}
 */
proto.stailer_external_admin.DeliveryAreaGroup.fromObject = function(obj) {
  var msg = new proto.stailer_external_admin.DeliveryAreaGroup();
  obj.groupId != null && jspb.Message.setField(msg, 2, obj.groupId);
  obj.groupName != null && jspb.Message.setField(msg, 3, obj.groupName);
  obj.shopId != null && jspb.Message.setField(msg, 4, obj.shopId);
  obj.siteType != null && jspb.Message.setField(msg, 5, obj.siteType);
  obj.id != null && jspb.Message.setField(msg, 6, obj.id);
  obj.createdAt && jspb.Message.setWrapperField(
      msg, 7, google_protobuf_timestamp_pb.Timestamp.fromObject(obj.createdAt));
  obj.updatedAt && jspb.Message.setWrapperField(
      msg, 8, google_protobuf_timestamp_pb.Timestamp.fromObject(obj.updatedAt));
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stailer_external_admin.DeliveryAreaGroup}
 */
proto.stailer_external_admin.DeliveryAreaGroup.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stailer_external_admin.DeliveryAreaGroup;
  return proto.stailer_external_admin.DeliveryAreaGroup.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stailer_external_admin.DeliveryAreaGroup} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stailer_external_admin.DeliveryAreaGroup}
 */
proto.stailer_external_admin.DeliveryAreaGroup.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setGroupId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setGroupName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setShopId(value);
      break;
    case 5:
      var value = /** @type {!proto.type.EcSite.SiteType} */ (reader.readEnum());
      msg.setSiteType(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 7:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 8:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdatedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stailer_external_admin.DeliveryAreaGroup.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stailer_external_admin.DeliveryAreaGroup.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stailer_external_admin.DeliveryAreaGroup} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stailer_external_admin.DeliveryAreaGroup.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGroupId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getGroupName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getShopId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSiteType();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string group_id = 2;
 * @return {string}
 */
proto.stailer_external_admin.DeliveryAreaGroup.prototype.getGroupId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.stailer_external_admin.DeliveryAreaGroup} returns this
 */
proto.stailer_external_admin.DeliveryAreaGroup.prototype.setGroupId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string group_name = 3;
 * @return {string}
 */
proto.stailer_external_admin.DeliveryAreaGroup.prototype.getGroupName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.stailer_external_admin.DeliveryAreaGroup} returns this
 */
proto.stailer_external_admin.DeliveryAreaGroup.prototype.setGroupName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string shop_id = 4;
 * @return {string}
 */
proto.stailer_external_admin.DeliveryAreaGroup.prototype.getShopId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.stailer_external_admin.DeliveryAreaGroup} returns this
 */
proto.stailer_external_admin.DeliveryAreaGroup.prototype.setShopId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional type.EcSite.SiteType site_type = 5;
 * @return {!proto.type.EcSite.SiteType}
 */
proto.stailer_external_admin.DeliveryAreaGroup.prototype.getSiteType = function() {
  return /** @type {!proto.type.EcSite.SiteType} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.type.EcSite.SiteType} value
 * @return {!proto.stailer_external_admin.DeliveryAreaGroup} returns this
 */
proto.stailer_external_admin.DeliveryAreaGroup.prototype.setSiteType = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional string id = 6;
 * @return {string}
 */
proto.stailer_external_admin.DeliveryAreaGroup.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.stailer_external_admin.DeliveryAreaGroup} returns this
 */
proto.stailer_external_admin.DeliveryAreaGroup.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional google.protobuf.Timestamp created_at = 7;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.stailer_external_admin.DeliveryAreaGroup.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 7));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.stailer_external_admin.DeliveryAreaGroup} returns this
*/
proto.stailer_external_admin.DeliveryAreaGroup.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.stailer_external_admin.DeliveryAreaGroup} returns this
 */
proto.stailer_external_admin.DeliveryAreaGroup.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.stailer_external_admin.DeliveryAreaGroup.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional google.protobuf.Timestamp updated_at = 8;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.stailer_external_admin.DeliveryAreaGroup.prototype.getUpdatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 8));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.stailer_external_admin.DeliveryAreaGroup} returns this
*/
proto.stailer_external_admin.DeliveryAreaGroup.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.stailer_external_admin.DeliveryAreaGroup} returns this
 */
proto.stailer_external_admin.DeliveryAreaGroup.prototype.clearUpdatedAt = function() {
  return this.setUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.stailer_external_admin.DeliveryAreaGroup.prototype.hasUpdatedAt = function() {
  return jspb.Message.getField(this, 8) != null;
};


goog.object.extend(exports, proto.stailer_external_admin);
